import tw, { styled } from 'twin.macro';
import { RadioProps } from '.';

export default styled.input<RadioProps & { hasError: boolean }>`
    && {
        ${tw`mr-2 mt-0.5 h-4 w-4 text-green-500 border border-gray-300 focus:(ring-blue-500) cursor-pointer checked:(bg-green-500 border-transparent)`}
        ${({ hasError }) => hasError && tw`border-red-300`}
    }
`;
